class FilterGroup {
	constructor(list, title, name, controller) {
		this.list = list;
		this.name = name;
		this.controller = controller;
		this.filters = [];
		this.initialized = false;

		this.elem = UI.div('m-2', [
			UI.htm('h5', 'text-xl font-bold', title),
			this.filtersElem = UI.div()
		]);

		controller.filterGroup = this;

		onEv(document, 'filtersChanged', this.update.bind(this));
		this.update();
	}

	update() {
		this.filters = [];
		this.filtersElem.innerHTML = '';
		for (let f of this.controller.filters) {
			let filter = new Filter(this, f[0], f[1]);
			if (this.list.saved[this.name]) filter.checked = this.list.saved[this.name].split(',').map(s => parseInt(s)).indexOf(f[0]) !== -1;
			this.filters.push(filter);
			this.filtersElem.append(filter.row);
		}
	}

	get active() {
		return this.filters.filter(f => f.checked).length > 0;
	}

	get toArray() {
		return this.filters.filter(f => f.checked).map(f => f._id);
	}

	get toString() {
		return this.filters.filter(f => f.checked).map(f => `${this.name}[]=${f.id}`).join('&');
	}
	
	clear() {
		this.filters.forEach(f => f.clear());
	}
}

class Status {
	constructor() {
		this.filters = [
			[0, 'Active'],
			[1, 'Complete'],
			[2, 'Exchanged'],
		]
	}
}